export default __webpack_public_path__ + "bec44b91786614da151c282588f54341.png";